import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";
import { api } from "src/constants/global-const";

const orderInstance: AxiosInstance = axios.create({
    baseURL: api + '/api/v1',
});

const companyserviceurl: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl + "/api/v1/oms",
});

const basecompanyserviceurl: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl,
});

const companyserviceurlevent: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl,
});

orderInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
basecompanyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurlevent.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

// Attach 403 refresh-and-retry interceptors
attachRefreshInterceptor(orderInstance);
attachRefreshInterceptor(companyserviceurl);
attachRefreshInterceptor(basecompanyserviceurl);
attachRefreshInterceptor(companyserviceurlevent);

export const getCompanyList = () => {
    return orderInstance.get("/company/details?list=true&fields=code,name,shortcode,instance_type");
};

export const getStockists = (payload: any) => {
    return companyserviceurl.get(`/po/stockists`, {
        params: {
            company_code: payload?.company_code,
            counter_codes: payload?.counter_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            division_codes: payload?.division_codes,
            item_codes: payload?.item_codes,
            module_code: payload?.module_code,
            search: payload?.search,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};


export const getOrders = (payload: any) => {
    return companyserviceurl.get(`/po/orders`, {
        params: {
            company_code: payload?.company_code,
            counter_codes: payload?.counter_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            division_codes: payload?.division_codes,
            item_codes: payload?.item_codes,
            company_stockist_codes: payload?.company_stockist_codes,
            stockist_ids: payload?.stockist_ids,
            module_code: payload?.module_code,
            search: payload?.search,
            order_type: payload?.order_type //M10-12019
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const getStateList = () => {
    return orderInstance.get("/state/details?fields=state_code,state_name");
};

export const getDivisionList = (payload: any) => {
    return orderInstance.get(`/division/list`, {
        params: {
            company_code: payload?.company_code,
            search: payload?.search,
        },
    });
};

export const getProducts = (payload: any) => {
    return companyserviceurl.get(`/po/products`, {
        params: {
            company_code: payload?.company_code,
            counter_codes: payload?.counter_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            division_codes: payload?.division_codes,
            item_codes: payload?.item_codes,
            company_stockist_codes: payload?.company_stockist_codes,
            stockist_ids: payload?.stockist_ids,
            module_code: payload?.module_code,
            search: payload?.search,
            order_type: payload?.order_type //M10-12019
        },
        headers: {
            company_code: payload?.company_code,
        }
    });

};

export const getCounterList = (payload: any) => {
    return companyserviceurl.get(`/po/counters`, {
        params: {
            company_code: payload?.company_code,
            counter_codes: payload?.counter_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            division_codes: payload?.division_codes,
            item_codes: payload?.item_codes,
            company_stockist_codes: payload?.company_stockist_codes,
            stockist_ids: payload?.stockist_ids,
            module_code: payload?.module_code,
            search: payload?.search,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};


export const generatePo = (payload: any) => {
    return companyserviceurl.post(`/po/generate`, payload, {
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const getFilteredPo = (payload: any) => {
    return companyserviceurl.get(`/po/filtered`, {
        params: {
            company_code: payload?.company_code,
            counter_codes: payload?.counter_codes,
            order_codes: payload?.order_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            division_codes: payload?.division_codes,
            item_codes: payload?.item_codes,
            comp_stockist_codes: payload?.comp_stockist_codes,
            search: payload?.search,
            stockist_ids: payload?.stockist_ids,
            // invoice_date: payload?.invoice_date,
        },
    });
};

export const getFilteredPoBatches = (payload: any) => {
    return companyserviceurl.get(`/po/batches`, {
        params: {
            company_code: payload?.company_code,
            date_to: payload?.date_to,
            date_from: payload?.date_from,
            item_codes: payload?.item_codes,
            stockist_ids: payload?.stockist_ids,
            division_codes: payload?.division_codes,
            order_ids: payload?.order_ids,
            state_codes: payload?.state_codes,
            counter_codes: payload?.counter_codes,
            po_generatetype: payload?.po_generatetype,
            module_code: payload?.module_code,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};


// Whether the PO API push ("PO submit") is built and enabled for a company on a module, read from
// OMS po_grouping_config. Replaces the company allowlist this screen used to carry, so enabling a
// company is a DB row edit rather than a frontend release.
export const getPoApiPushConfig = (payload: any) => {
    return companyserviceurl.get(`/po/api-push-config`, {
        params: {
            company_code: payload?.company_code,
            module_code: payload?.module_code,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};


export const getBatchPoList = (payload: any) => {
    return companyserviceurl.get(`/po`, {
        params: {
            po_batch_id: payload?.po_batch_id,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const getBatchPoPayloadList = (payload: any) => {
    return companyserviceurl.get(`/po/api-payload`, {
        params: {
            po_batch_id: payload?.po_batch_id,
            po_id: payload?.po_id,
            po_type: payload?.po_type
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const getBatchPoItems = (payload: any) => {
    return companyserviceurl.get(`/po/items`, {
        params: {
            po_id: payload?.po_id,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const downloadBatchPo = (payload: any) => {
    return companyserviceurl.get(`/po/download-batch`, {
        params: {
            company_code: payload?.company_code,
            po_batch_id: payload?.po_batch_id,
            batch_id: payload?.batch_id,
            po_generatetype: payload?.po_generatetype,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const getPoItem = (payload: any) => {
    return companyserviceurl.get(`/order/po-item`, {
        params: payload,
        headers: {
            company_code: payload?.company_code,
        }
    });
};

export const reconcilePoItem = (payload: any) => {
    return companyserviceurl.get(`/order/item-reconcile`, {
        params: {
            order_product_id: payload?.order_product_id,
        },
        headers: {
            company_code: payload?.company_code,
        }
    });
};

  export const reconcilePoFile = (payload: any) => {
    // const formData = new FormData();
    // formData.append("reconcile-file", payload?.file);
    
    return companyserviceurl.post(`/po/file-reconcile`, payload, {
      headers: {
        company_code: payload?.company_code,
        // "Content-Type": "multipart/form-data",
      },
    });
  };
        
  export const getSignedUrlPO = (payload: any) => {
    return companyserviceurl.post(`/po/s3-url`, payload, {
        headers: {
            company_code: payload?.company_code,
        }
    });
  }
  
  export const uploadFileToPresignedUrl = (file: File, uploadUrl: string, company_code: string) => {
    return fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
        'company_code': company_code,
      },
    });
  }

  // Module -> SO Type configuration (OMS module_order_type_hdr). Drives both dropdowns on the
  // reconciliation screen, so enabling a module/type is a DB row edit rather than a release.
  export const getReconciliationModuleTypes = (payload?: any) => {
    return companyserviceurl.get(`/po/reconciliation-module-types`, {
      params: {
        process: payload?.process || 'RECONCILIATION',
      },
      headers: {
        company_code: payload?.company_code,
      }
    });
  }

  export const getReconciliationRecords = (payload: any) => {
    return companyserviceurl.get(`/po/reconciliation-all`, {
      params: {
        company_code: payload?.company_code,
        module_code: payload?.module_code,
        page: payload?.page,
        limit: payload?.limit,
        date_from: payload?.date_from,
        date_to: payload?.date_to,
      },
      headers: {
        company_code: payload?.company_code,
      }
    });
  }
//M10-11344
export const getPoGeneration = (payload: any) => {
    return basecompanyserviceurl.post(`/event/po/submit/add`, payload, {
        headers: {
            company_code: payload?.data?.company_code,
        }
    });
}
//M10-11344

// PO_REPUSH_EDIT — tick/untick a successfully pushed PO (no SO number yet) for re-push.
export const updatePoRepushFlag = (payload: any) => {
    return basecompanyserviceurl.put(`/event/po/repush`, payload, {
        headers: {
            company_code: payload?.data?.company_code,
        }
    });
}

//M10-12438
export const removePoApi = (payload: any, company_code: any) => {
    return basecompanyserviceurl.delete(`/event/po/remove-po`, {
        data:payload, 
        headers: {
            company_code: company_code,
        }
    });
}
//M10-12438

export const getPendingPOReports = (query: any, company_code: any) => {
    return companyserviceurl.get(`/po/pending-po-export?${query}`, {
        headers: {
            company_code: company_code,
        }
    })
};